<div *ngIf="!isSubmitted">
  <fi-services
    [applicationId]="applicationId"
    [services]="services$ | async"
    [hasConfirmedDiagnosis]="hasConfirmedDiagnosis$ | async"
    [hasErrors]="hasErrors$ | async"
    (formError)="onFormError()"
    (formUpdated)="onFormUpdated($event)"
  >
  </fi-services>
</div>
